import React from "react";
import { map, range } from "lodash";
import styled from "styled-components";
import { localize } from "@backpacker/number";
import { Locale } from "@linkfluence/models/locale";
import { Platform, getPlatformColor } from "@linkfluence/models/platform";
import Icon from "@ui-kit/icon";
import Tooltip from "@ui-kit/tooltip/description";

const NB_STARS = 5;
const MAX_VALUE = 5;

const getFilledStarStyle = (value, size, i) => {
  const indice = i + 1 - value;
  const full = indice <= 0;
  const semi = indice > 0 && indice < 1;
  return {
    width: full ? size : semi ? size * (1 - indice) : 0,
  };
};

const getWrapperStyle = (size) => ({ marginRight: size + 2 });

const Root = styled.div`
  display: inline-block;
`;

const Stars = styled.span`
  position: relative;
  color: ${getPlatformColor(Platform.Review)};
`;

const Star = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
`;

interface IProps {
  value: number;
  size?: number | string;
  locale: Locale;
  tooltip?: string;
  isTooltipDisabled?: boolean;
}

const UiKitRating = ({
  value,
  size = 12,
  locale,
  tooltip = "",
  isTooltipDisabled,
}: IProps) => {
  const tooltipTitle =
    localize(locale, value) + " / " + localize(locale, MAX_VALUE);
  return (
    <Tooltip
      placement="top"
      title={tooltip !== "" ? tooltipTitle : ""}
      content={tooltip === "" ? tooltipTitle : tooltip}
      disabled={isTooltipDisabled}
    >
      <Root>
        {map(range(NB_STARS), (i) => (
          <Stars key={i} style={getWrapperStyle(size)}>
            <Star>
              <Icon glyph="star" size={size} />
            </Star>
            <Star style={getFilledStarStyle(value, size, i)}>
              <Icon glyph="star-filled" size={size} />
            </Star>
          </Stars>
        ))}
      </Root>
    </Tooltip>
  );
};

export default UiKitRating;
